import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-foreground-200">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-5">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-bold text-sm">
                3D
              </div>
              <span className="font-heading text-lg font-semibold tracking-wider text-foreground-50 whitespace-nowrap">
                3D's Card Data
              </span>
            </Link>
            <p className="text-sm leading-relaxed text-foreground-400 mb-6">
              3Dカードデータ解析とビッグデータ分析を通じて、企業のデータ資産を最大限に活用するソリューションを提供します。
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-500/30 text-foreground-400 hover:text-foreground-50 hover:border-foreground-200 transition-all duration-300" aria-label="Twitter">
                <i className="ri-twitter-x-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-500/30 text-foreground-400 hover:text-foreground-50 hover:border-foreground-200 transition-all duration-300" aria-label="LinkedIn">
                <i className="ri-linkedin-fill text-sm"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-100 mb-5 tracking-wider">ナビゲーション</h4>
            <ul className="space-y-3">
              <li><Link to="/" className="text-sm text-foreground-400 hover:text-foreground-100 transition-colors duration-200">ホーム</Link></li>
              <li><Link to="/company" className="text-sm text-foreground-400 hover:text-foreground-100 transition-colors duration-200">会社概要</Link></li>
              <li><Link to="/services" className="text-sm text-foreground-400 hover:text-foreground-100 transition-colors duration-200">事業紹介</Link></li>
              <li><Link to="/contact" className="text-sm text-foreground-400 hover:text-foreground-100 transition-colors duration-200">お問い合わせ</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-100 mb-5 tracking-wider">法的情報</h4>
            <ul className="space-y-3">
              <li><Link to="/privacy" className="text-sm text-foreground-400 hover:text-foreground-100 transition-colors duration-200">プライバシーポリシー</Link></li>
              <li><Link to="/terms" className="text-sm text-foreground-400 hover:text-foreground-100 transition-colors duration-200">利用規約</Link></li>
              <li><Link to="/cookie" className="text-sm text-foreground-400 hover:text-foreground-100 transition-colors duration-200">Cookie ポリシー</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-100 mb-5 tracking-wider">お問い合わせ</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-sm text-foreground-500 mt-0.5"></i>
                <span className="text-sm text-foreground-400 leading-relaxed">〒106-0032 東京都港区六本木6-10-1<br />六本木ヒルズ森タワー 22F</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-sm text-foreground-500"></i>
                <span className="text-sm text-foreground-400">03-6441-3820</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-sm text-foreground-500"></i>
                <a href="mailto:admin@3dscarddata.jp" className="text-sm text-foreground-400 hover:text-foreground-100 transition-colors duration-200">admin@3dscarddata.jp</a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-14 pt-8 border-t border-foreground-700/20 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} 3D's Card Data株式会社. All rights reserved.
          </p>
          <p className="text-xs text-foreground-600">
            DATA DRIVEN FUTURE
          </p>
        </div>
      </div>
    </footer>
  );
}